import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class GatewatPayment extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/gateway/payment'
    super(store, path)
  }
}
